import { useEffect, useState } from "react";
import useFirestore from "shared/hooks/useFirestore";
import useGetBranchId from "shared/hooks/useGetBranchId";

interface counsel{
    action_detail:string,
    counsel_detail:string,
    counsel_date:string
}

const useStudentCounsel = (student_uid:string) => {
    const {getBranchId} = useGetBranchId();
    const { readFirestoreWithSort } = useFirestore();
    const [counsel, setCounsel] = useState<counsel>({
        action_detail:"",
        counsel_detail:"",
        counsel_date:""
    })

    useEffect(() => {
        if(student_uid){
            getLastCounsel();
        }
    }, [student_uid])

    const getLastCounsel = async() => {
        const branch_id = await getBranchId();
        readFirestoreWithSort(`Counsel/${branch_id}/${student_uid}`, {name:"counsel_date", direction:"asc"}).then(res => {
            res.forEach((doc:any) => {
                const data = doc.data();
                setCounsel({
                    action_detail:data.action_detail,
                    counsel_date:data.counsel_date,
                    counsel_detail:data.counsel_detail
                })
                return;
            })
        })
    }

    return {counsel}
}

export default useStudentCounsel;